import { BusiniessUnitSpeciality } from "./businiess-unit-speciality";
import { BusinessUnitType } from "../../lookups/models/business-unit-type";


export class BusinessUnit {

  constructor(_active: boolean) {
    this.active = _active;
  }
  id: number;
  name: string;
  active: boolean;
  parentId: number;
  createdBy: string;
  creationDate: Date;
  lastModifiedBy: string;
  lastModificationDate: Date;
  buisnessUnitSpecialities: BusiniessUnitSpeciality[];
  businessUnitSpecialities: BusiniessUnitSpeciality[];
  parentBusinessUnit: BusinessUnit;
  businessUnitType: BusinessUnitType;
  businessUnitTypeId: number;
  businessUnitTypeName: string;
  parentName: string;
  endDate?: Date;
  visitCustomFieldName: string;
  coachingMonthlyTargets?: { year: number, month: number, target: number }[];

  businessUnitOrganizationTypesParents: any;
  businessUnitOrganizationTypesChilds: any;
  businessUnitOrganizationTypes: any;
}


export class BusinessUnitTree {
  data: BusinessUnit;
  children: BusinessUnitTree[];
}
